export default __webpack_public_path__ + "static/media/lock.396dc695.png";